// extracted by mini-css-extract-plugin
export var filterIncDec = "_3d-0";
export var leftBorder = "_3d-1";
export var rightBorder = "_3d-2";
export var stringInput = "_3d-3";